import React from 'react';
import { siteConfig } from '../data/works';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#000',
      color: '#fff',
      padding: '64px 32px'
    }}>
      <div 
        className="footer-grid"
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '48px'
        }}
      >
        <div>
          <h4 style={{
            fontSize: '0.65rem',
            fontWeight: 400,
            letterSpacing: '0.2em',
            marginBottom: '20px',
            textTransform: 'uppercase',
            color: '#888'
          }}>
            À propos
          </h4>
          <p style={{
            fontSize: '0.72rem',
            lineHeight: 1.8,
            color: '#aaa'
          }}>
            {siteConfig.about}
          </p>
        </div>

        <div>
          <h4 style={{
            fontSize: '0.65rem',
            fontWeight: 400,
            letterSpacing: '0.2em',
            marginBottom: '20px',
            textTransform: 'uppercase',
            color: '#888'
          }}>
            Contact
          </h4>
          <div style={{
            fontSize: '0.72rem',
            lineHeight: 2,
            color: '#aaa'
          }}>
            <p>{siteConfig.contact.email}</p>
            <p>{siteConfig.contact.address}</p>
          </div>
        </div>

        <div>
          <h4 style={{
            fontSize: '0.65rem',
            fontWeight: 400,
            letterSpacing: '0.2em',
            marginBottom: '20px',
            textTransform: 'uppercase',
            color: '#888'
          }}>
            Social
          </h4>
          <div style={{ display: 'flex', gap: '24px' }}>
            {siteConfig.social.map(item => (
              <a 
                key={item.name}
                href={item.url}
                style={{
                  fontSize: '0.72rem',
                  color: '#aaa',
                  textDecoration: 'none',
                  letterSpacing: '0.05em',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#fff'}
                onMouseLeave={(e) => e.target.style.color = '#aaa'}
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: '1200px',
        margin: '48px auto 0',
        paddingTop: '24px',
        borderTop: '1px solid #222',
        textAlign: 'center'
      }}>
        <p style={{
          fontSize: '0.6rem',
          color: '#555',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }}>
          © {new Date().getFullYear()} {siteConfig.name}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
